import { Import } from '@sonar-software/sonar-imports';
import { useSonarSelector } from '../useSonarSelector';
import { createAsyncSelectors, createSonarSelector } from '@lib/selectors';

const empty: Import[] = [];

const latestSyncSelectors = createAsyncSelectors((state) => state.imports.latest.salesforce);
const singleSyncSelector = createSonarSelector((state) => (latestSyncSelectors.data(state) ?? empty)[ 0 ]);

function compare(prev: Import, next: Import): boolean {
	if ((!prev && next) || (prev && !next)) {
		return false;
	}

	if (!prev && !next) {
		return true;
	}

	return (
		prev.id === next.id &&
		prev.status === next.status &&
		prev.finishedOn === next.finishedOn &&
		prev.logs.length === next.logs.length
	);
}

export function useLatestSalesforceSync(): Import | null | undefined {
	return useSonarSelector(singleSyncSelector, compare);
}
